/**
 * Blog article FAQ drawers.
 * After an h2 "FAQ" (case-insensitive), wrap each following h3 + answer
 * in <details> until the next h2. Items start closed; multiple may stay open.
 */
(function () {
  function init() {
    var root = document.querySelector('.article--content.rte');
    if (!root || root.dataset.articleFaqReady) return;
    root.dataset.articleFaqReady = 'true';

    var faqH2 = null;
    var children = root.children;
    var i;

    for (i = 0; i < children.length; i++) {
      if (
        children[i].tagName === 'H2' &&
        children[i].textContent.trim().toLowerCase() === 'faq'
      ) {
        faqH2 = children[i];
        break;
      }
    }
    if (!faqH2) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'article-faq';

    var answer = null;
    var el = faqH2.nextElementSibling;

    while (el && el.tagName !== 'H2') {
      var next = el.nextElementSibling;

      if (el.tagName === 'H3') {
        var details = document.createElement('details');
        details.className = 'article-faq__item';

        var summary = document.createElement('summary');
        summary.className = 'article-faq__question';
        el.classList.add('article-faq__heading');
        summary.appendChild(el);

        var icon = document.createElement('span');
        icon.className = 'article-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.appendChild(icon);

        answer = document.createElement('div');
        answer.className = 'article-faq__answer';

        details.appendChild(summary);
        details.appendChild(answer);
        wrapper.appendChild(details);
      } else if (answer) {
        answer.appendChild(el);
      }

      el = next;
    }

    if (!wrapper.childElementCount) return;

    var insertAfter = faqH2;
    var sibling = faqH2.nextElementSibling;
    while (sibling && sibling.tagName !== 'H2') {
      insertAfter = sibling;
      sibling = sibling.nextElementSibling;
    }
    insertAfter.after(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
